import { Chart } from '@frontend/chart/types';

export const PUDO_TRANSACTION_VOLUME_BY_RECEIVER_LIST_CHART_MOCK_DATA: Chart = {
    series: [
        { name: 'Julie Maes', data: [{ label: 'full_period', value: 38 }] },
        { name: 'Emma Claes', data: [{ label: 'full_period', value: 31 }] },
        { name: 'Lucas Janssens', data: [{ label: 'full_period', value: 24 }] },
        { name: 'Sarah Peeters', data: [{ label: 'full_period', value: 19 }] },
        { name: 'Thomas De Smet', data: [{ label: 'full_period', value: 14 }] },
        { name: 'Anna Vermeulen', data: [{ label: 'full_period', value: 9 }] }
    ]
};
